import React, { useEffect } from 'react';
import Auth from '@Services/Auth';
import Page from '@Containers/Page';
import Button from '@Components/Button';
import RouteChangeTracking from '@Services/RouteChangeTracking';

import './Logout.scss';

export default function Logout() {
  const goToLandingPage = () => {
    Auth.goToLandingPage(true);
  };
  useEffect(() => {
    RouteChangeTracking.trackOnRouteChangeSuccess();
  }, []);

  const headerText = "You're now logged out from Reaxys";

  return (
    <Page withHeader headerType="clean" withFooter pageClassName="react-page-logout-page" className="react-page-static__wrapper">
      <main id="main-content" tabIndex="-1" aria-label="Logout page">
        <div className="logout-page__screen page-container--hexagons rx-left-gutter rx-right-gutter">
          <h1 className="e2e-logout-page-header logout-page__screen_header  u-els-font-size-h2">{headerText}</h1>
          <div className="logout-page__screen_content">
            <p>
              By clicking the logout button your Reaxys session has been ended.You may return to the query page by clicking the hyperlink
              provided below or you may close your browser.
              <br />
              <Button
                onClick={goToLandingPage}
                buttonConfig={{
                  type: 'link',
                  size: 'sm',
                  iconOnly: true,
                  e2eName: 'e2e-name-logout',
                  label: "Return to Reaxys' home page",
                }}
              />
            </p>
          </div>
        </div>
      </main>
    </Page>
  );
}
